import { Card, Flex, Text } from "@jsq/ds/core";
import {
  useFormContext,
  FormRadioGroup,
  FormRadioButton,
  FormTextInput,
  FormTextarea,
} from "@jsq/ds/forms";
import RiskRatingRadioBar from "../../../Profiles/common/RiskRatingRadioBar";
import { accountHolderExplanation } from "../../AccountForm/styles_vanilla.css";
import { PaymentInstructionFormValues } from "../../types";

const BeneficiaryAccountForm = () => {
  const { values } = useFormContext<PaymentInstructionFormValues>();

  return (
    <Card>
      <Flex flexDirection="column" gap={24}>
        <FormRadioGroup name="accountNameMatches">
          <Text variant="strong-md">Does account match bank account name?</Text>
          <FormRadioButton value="yes">
            Account (investor, owner, or controller) exactly matches bank account name
          </FormRadioButton>
          <FormRadioButton value="no">
            Account (investor, owner, or controller) does not exactly match bank account name
          </FormRadioButton>
        </FormRadioGroup>
        {values.accountNameMatches === "no" && (
          <Flex flexDirection="column" gap={24}>
            <FormTextInput name="bankAccountName" label="Bank account name" isFullWidth />
            <FormTextarea
              name="explanation"
              label="Explanation"
              className={accountHolderExplanation}
              placeholder="Please explain how this bank account owner is related to the investor"
              isFullWidth
            />
          </Flex>
        )}
        <RiskRatingRadioBar form="bankAccount" />
      </Flex>
    </Card>
  );
};
export default BeneficiaryAccountForm;
